export function GlassCard({ children, className = "", hover = false, ...props }) {
  return (
    <div
      className={`glass rounded-2xl ${hover ? "glow-hover" : ""} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export default GlassCard;
